import {Component, OnInit, Input, ViewChild, ViewEncapsulation, OnDestroy} from '@angular/core';
import { ParkProvider } from '@providers/park.provider';
import { Area } from '@core/area';
import { BroadcastService } from '@core/broadcast/broadcast.service';
import { LandEvent } from '@core/broadcaster/LandEvent';
import { OpenLandModalEvent } from '../../../events/OpenLandModalEvent';
import { NotificationService } from '@core/notification/notification.service';
import { RefreshEvent } from '../../../events/RefreshEvent';
import { ThingModalEvent } from '../../../events/ThingModalEvent';
import { RedrawMapEvent } from '../../../events/RedrawMapEvent';
import { ThingProvider } from '@providers/thing.provider';

import {KngDrawerService} from "@layout/kingswell/services/kngDrawer.service";
import {EditThresholdComponent} from "@components/things/threshold/editThreshold.component";
import {ThingsThresholdComponent} from "@components/things/threshold/threshold.component";
import { EditThingsAttributesComponent } from '@components/things/attributes/edit.component';
import { ActivatedRoute } from '@angular/router';
import { ThingsUtil } from '../../../util/things';
import {Location} from "@angular/common";
import { KngActivityIndicatorService } from '@layout/kingswell/services/kngActivityIndicator.service';
import { ThingService } from '@core/thing/thing.service';
import { ThingConfig } from '@core/thing/thingConfig';
import {KngModalService} from "@layout/kingswell/services/kngModal.service";
import {Subscription} from "rxjs/Subscription";

@Component({
  selector: 'things-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class ThingsDetailsComponent implements OnInit, OnDestroy {

  @Input()
  public thing: any;

  public open: boolean = true;

  public config: ThingConfig;

  public isResource: boolean;

  private refresherSubscription: Subscription;

  constructor(private thingModal: ThingModalEvent, private thingService: ThingService,
              private park: ParkProvider, private thingProvider: ThingProvider,
              private redrawMap: RedrawMapEvent, private refresher: RefreshEvent, private kngDrawerService: KngDrawerService,
              private route: ActivatedRoute, private thingsUtil: ThingsUtil,
              private _location: Location, private kngActivityIndicator: KngActivityIndicatorService,
              private notification: NotificationService, private kngModalService : KngModalService) {
    let thingId = this.route.snapshot.params['thingId'];
    this.refreshThing(thingId);
   }

  ngOnInit() {
    this.refresher.on().subscribe(data => {
      if (data === 'thingsDetails.refresh') {
        this.refreshThing(this.thing.thingId).then(thing => {
          this.redrawMap.fire('thingsDetailMap.redraw', this.thing);
        });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.refresherSubscription)
      this.refresherSubscription.unsubscribe();
  }

  isOpen() {
    return this.open;
  }

  refreshThing(thingId) {
    return new Promise((resolve, reject) => {
      this.kngActivityIndicator.show();
      this.thingService.getThing(thingId).then(res => {
        this.thing = res;
        this.config = this.thingsUtil.getConfig(this.thing);
        this.isResource = this.thingsUtil.isResource(this.thing);
        this.kngActivityIndicator.close();
        resolve(this.thing);
      });
    });
  }

  close() {
    //this.open = false;
    this._location.back();
  }

  isCan() {
    return this.thingsUtil.isCan(this.thing);
  }

  isRestroom() {
    return this.thingsUtil.isRestroom(this.thing);
  }

  isTimeBased() {
    return this.thingsUtil.isTimeBasedTask(this.thing);
  }

  getThingHeader(){
    if( this.isCan() ){
      return "Can";
    }else if( this.isRestroom() ){
      return "Restroom";
    }else if( this.isTimeBased() ){
      return "Time-Based";
    }else{
      return "Unknown Thing"
    }
  }

  // This is also in map.ts. Should create a util service for this.
  getIconType() {
    return this.thingsUtil.getIcon(this.thing);
  }

  openEditAbout($event) {
    $event.preventDefault();
    $event.stopPropagation();

    this.thingModal.fire('thingsEdit.open', this.thing);
  }

  getActiveText() {
    return this.isCan() ? 'active' : 'open';
  }

  getInactiveText() {
    return this.isCan() ? 'inactive' : 'closed';
  }

  openThreshold($event) {
    $event.preventDefault();
    $event.stopPropagation();

    let drawer = this.kngDrawerService.launch(EditThresholdComponent,{
      windowClass: "kng-drawer-threshold"
    });
    drawer.componentInstance.thing = this.thing;

    drawer.result
      .then(res=>{
        // console.log(res);
      })
      .catch(err=>{
        console.log("cancel");
      })
  }

  openEditAttributes($event) {
    $event.preventDefault();
    $event.stopPropagation();

    let windowClass = "";
    if (this.isCan()) {
      windowClass = "kng-drawer-attributes-cans";
    } else {
      windowClass = "kng-drawer-attributes-restrooms";
    }

    let drawer = this.kngDrawerService.launch(EditThingsAttributesComponent,{
      windowClass: windowClass
    });
    drawer.componentInstance.thing = this.thing;

    drawer.result.then(res=>{
      // show success modal
    })
    .catch(err=>{

    });
  }

  openDelete($event) {
    $event.preventDefault();
    $event.stopPropagation();

    let modalInstance = this.kngModalService.launch({
      type : 'alert',
      title : 'Are you sure you want to<br/>delete this resource?',
      contents : 'Deleting a resource will immediately remove it from all<br/>D Clean applications.',
      button: [
        {title: 'No, Cancel', type: 'secondary', action: 'cancel'},
        {title: 'Yes, Delete', type: 'primary', action: 'delete'},
      ]
    });

    modalInstance.result.then(res => {
      if (res == 'delete') {
        this.kngActivityIndicator.show();
        this.thingProvider.deleteThing(this.thing)
          .then(res => {
            this.kngActivityIndicator.close();
            this.notification.show('success', 'You have successfully deleted ' + this.thing.name + '.');
            this._location.back();
          })
          .catch(err => {
            console.error(err);
            this.kngActivityIndicator.close();
            this.notification.show('alert', 'There was a problem deleting ' + this.thing.name + '.');
          });
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/components/things/details/details.component.ts